import type { BaseDataItem } from '@wix/editor-elements-definitions';
import type { CompDefinition } from '@wix/editor-elements-types/thunderbolt';
import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

import type { SocialPlayerSharedData } from '../../SocialPlayerShared/SocialPlayersShared.types';

export type SocialPlayerFacebookDefinition = CompDefinition<
  never,
  SocialPlayerSharedData & BaseDataItem,
  never,
  never
>;

export const props = withCompInfo<
  SocialPlayerSharedData,
  SocialPlayerFacebookDefinition
>()(['compData'], ({ compData }) => compData);

export default createComponentMapperModel({ props });
